module.exports = __webpack_public_path__ + "img/pictureimg.9ca0d37b.png";